import { createAction, props } from '@ngrx/store';
import {
    NotesAndActivities,
    NotesAndActivitiesEdit,
    NotesAndActivitiesOrientationNote
} from 'src/app/recruiting/candidates/new-profile/models/notes-and-activities.model';
import { OrientationSection } from 'src/app/travelxnew/models/orientation-profile/orientation-section.enum';

export const loadNotesAndActivities = createAction(
    '[NOTES AND ACTIVITIES COMPONENT] Load Notes and Activities',
    props<{ candidateId: number; limitHistory: boolean; section: OrientationSection }>()
);
export const loadNotesAndActivitiesSuccess = createAction(
    '[CANDIDATE NOTES AND ACTIVITIES API] Load Notes and Activities Successfully',
    props<{
        notesAndActivities: NotesAndActivities[];
        orientationNotes: NotesAndActivitiesOrientationNote[];
        candidateId: number;
        limitHistory: boolean;
    }>()
);
export const loadNotesAndActivitiesFailure = createAction(
    '[CANDIDATE NOTES AND ACTIVITIES API] Load Notes and Activities Failure',
    props<{ error: unknown }>()
);

export const loadRecruiterAssignment = createAction(
    '[NOTES AND ACTIVITIES COMPONENT] Load Recruiter Assignment',
    props<{
        candidateId: number;
        notesAndActivities: NotesAndActivities[];
        orientationNotes: NotesAndActivitiesOrientationNote[];
        limitHistory: boolean;
    }>()
);
export const loadRecruiterAssignmentSuccess = createAction(
    '[CANDIDATE RECRUITER ASSIGNMENT API] Load Recruiter Assignment Success',
    props<{
        notesAndActivities: NotesAndActivities[];
        orientationNotes: NotesAndActivitiesOrientationNote[];
        candidateId: number;
        limitHistory: boolean;
    }>()
);
export const loadRecruiterAssignmentFailure = createAction(
    '[CANDIDATE RECRUITER ASSIGNMENT API] Load Recruiter Assignment Failure',
    props<{ error: unknown }>()
);

export const addNotesAndActivities = createAction(
    '[NOTES AND ACTIVITIES COMPONENT] Add Notes and Activities',
    props<{ newNote: NotesAndActivitiesEdit }>()
);
export const addSectionNote = createAction(
    '[NOTES AND ACTIVITIES COMPONENT] Add Section Note',
    props<{ newNote: NotesAndActivitiesEdit }>()
);
export const addNotesAndActivitiesSuccess = createAction(
    '[CANDIDATE NOTES AND ACTIVITIES API] Add Notes and Activities Successfully',
    props<{ returnNote: NotesAndActivities }>()
);
export const addSectionNoteSuccess = createAction(
    '[CANDIDATE NOTES AND ACTIVITIES API] Add Section Note Successfully',
    props<{
        note: NotesAndActivities;
        orientationNote: NotesAndActivitiesOrientationNote;
    }>()
);
export const addNotesAndActivitiesFailure = createAction(
    '[CANDIDATE NOTES AND ACTIVITIES API] Add Notes and Activities Failure',
    props<{ error: unknown }>()
);

export const reloadNotes = createAction(
    '[NOTES AND ACTIVITIES COMPONENT] Reload Notes',
    props<{ candidateId: number; limitHistory: boolean; section: OrientationSection }>()
);
